<div class="modal-header" ngbAutofocus>
  <h4 class="modal-title">Confirm Account</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <div *ngIf="message" class="alert alert-warning d-flex align-items-start mb-3" role="alert">
    <i class="bi bi-exclamation-triangle-fill me-2 mt-1"></i>
    <div>{{ message }}</div>
  </div>
  <p>Enter your account password and click Continue to proceed.</p>
  <form class="row mb-4 form" [formGroup]="form">
    <label class="col-lg-12 col-form-label fw-semibold fs-8">Password</label>
    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <div class="input-group flex-nowrap">
            <input type="password" #psswdFld autocomplete="new-password" name="password" formControlName="password"
              class="form-control form-control-lg" placeholder="Enter password">
            <a class="input-group-text"
              (click)="psswdFld.getAttribute('type') === 'password' ? psswdFld.setAttribute('type', 'text') : psswdFld.setAttribute('type', 'password')">
              <i class="bi bi-eye"></i>
            </a>
          </div>
          <app-validation-message [form]="form" [showErrors]="showValidationErrors" [field]="'password'">
          </app-validation-message>
        </div>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-lg btn-primary" (click)="submitPassword();"><i
      class="bi bi-arrow-right fw-bold me-2"></i>
    Continue</button>
</div>
